var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-text"},[_c('data-table-customer',{attrs:{"baseUrl":this.baseUrl,"draw":_vm.draw,"status":this.status,"customerVisitPlanLineID":this.customerVisitPlanLineID},on:{"viewLog":_vm.handleViewLog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }